import React from 'react';
import { cn } from '../../utils/cn';

export function Skeleton({ variant = 'rect', className, style, ...rest }) {
  const shape = variant === 'circle' ? 'rounded-full' : variant === 'text' ? 'rounded' : 'rounded-md';
  return (
    <span
      aria-hidden
      className={cn(
        'block animate-shimmer bg-[length:200%_100%]',
        shape,
        className
      )}
      style={{
        background: 'linear-gradient(90deg, rgb(var(--ds-color-cream-2)) 0%, rgb(var(--ds-color-cream-3)) 50%, rgb(var(--ds-color-cream-2)) 100%)',
        backgroundSize: '200% 100%',
        ...style,
      }}
      {...rest}
    />
  );
}

export default Skeleton;
